import { Injectable, Type } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ComponentRegistryService {
  private registry = new Map<string, Type<any>>();

  register(selector: string, type: Type<any>): void {
    this.registry.set(selector, type);
  }

  get(selector: string): Type<any> | undefined {
    return this.registry.get(selector);
  }

  has(selector: string): boolean {
    return this.registry.has(selector);
  }

  getAll(): Map<string, Type<any>> {
    return this.registry;
  }
}
